<div mat-dialog-content class="dialog-update">
    <div fxLayout="row wrap" class="mb-20">
        Unit of Measurement: {{ data.uom }}
    </div>
    <div fxLayout="row wrap" class="mt-20">
        Description: {{ data.description }}
    </div>
</div>

